export const hasDropshippableOffer = (offers: guesthouse.ProductOffer[]): boolean => offers.some(offer => offer.classification === 'dropship');
